import React from 'react'

export const TabGlossaryContext = React.createContext({})
